import React from 'react';
import { Link } from 'react-router-dom';

const FocusConsultoria = () => {
  const solutions = [
    {
      title: 'Consultoria Estratégica',
      description: 'Desenvolvimento de estratégias personalizadas para o crescimento sustentável do seu negócio.',
      icon: '🎯'
    },
    {
      title: 'Gestão de Processos',
      description: 'Otimização e melhoria contínua dos processos organizacionais para maior eficiência.',
      icon: '⚙️'
    },
    {
      title: 'Desenvolvimento Organizacional',
      description: 'Fortalecimento da cultura organizacional e desenvolvimento de competências.',
      icon: '🏢'
    },
    {
      title: 'Análise de Mercado',
      description: 'Estudos detalhados do mercado para identificar oportunidades e ameaças.',
      icon: '📊'
    },
    {
      title: 'Planejamento Financeiro',
      description: 'Estruturação financeira e planejamento orçamentário para crescimento sustentável.',
      icon: '💰'
    },
    {
      title: 'Gestão de Mudanças',
      description: 'Acompanhamento e suporte na implementação de mudanças organizacionais.',
      icon: '🔄'
    }
  ];

  const benefits = [
    'Aumento da produtividade em até 40%',
    'Redução de custos operacionais',
    'Melhoria na qualidade dos produtos/serviços',
    'Fortalecimento da cultura organizacional',
    'Maior competitividade no mercado',
    'Crescimento sustentável do negócio'
  ];

  return (
    <div className="pt-32"> {/* Espaço para header fixo */}
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-focus-blue to-blue-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Focus Consultoria e Treinamento Empresarial
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-100">
              Transformamos empresas através de soluções personalizadas em consultoria e treinamento, 
              impulsionando o crescimento e a excelência operacional.
            </p>
            <Link
              to="/#contato"
              className="bg-focus-orange hover:bg-red-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              Solicite uma Consultoria
            </Link>
          </div>
        </div>
      </section>

      {/* Sobre o Serviço */}
      <section className="py-20 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-6">
                Por que escolher nossa consultoria?
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Com mais de 15 anos de experiência no mercado, nossa equipe de consultores especializados 
                oferece soluções sob medida para cada necessidade empresarial.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Utilizamos metodologias comprovadas e ferramentas modernas para garantir resultados 
                mensuráveis e duradouros para o seu negócio.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 bg-white rounded-lg shadow">
                  <div className="text-2xl font-bold text-focus-blue">500+</div>
                  <div className="text-sm text-gray-600">Projetos Realizados</div>
                </div>
                <div className="text-center p-4 bg-white rounded-lg shadow">
                  <div className="text-2xl font-bold text-focus-blue">98%</div>
                  <div className="text-sm text-gray-600">Taxa de Sucesso</div>
                </div>
              </div>
            </div>
            <div className="bg-focus-pink rounded-lg p-8">
              <h3 className="text-2xl font-bold text-focus-blue mb-6">Benefícios Comprovados</h3>
              <ul className="space-y-3">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-center">
                    <svg className="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Soluções Oferecidas */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              Nossas Soluções
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Oferecemos um portfólio completo de serviços de consultoria para atender todas as necessidades da sua empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className="bg-focus-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow group border border-gray-100"
              >
                <div className="bg-focus-blue w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform">
                  {solution.icon}
                </div>
                <h3 className="text-xl font-semibold text-focus-blue mb-3">
                  {solution.title}
                </h3>
                <p className="text-gray-600">
                  {solution.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Metodologia */}
      <section className="py-20 bg-focus-blue text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Nossa Metodologia
            </h2>
            <p className="text-lg text-blue-100 max-w-2xl mx-auto">
              Seguimos um processo estruturado e comprovado para garantir o sucesso dos nossos projetos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="text-xl font-semibold mb-2">Diagnóstico</h3>
              <p className="text-blue-100">Análise completa da situação atual da empresa</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="text-xl font-semibold mb-2">Planejamento</h3>
              <p className="text-blue-100">Desenvolvimento de estratégias personalizadas</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="text-xl font-semibold mb-2">Implementação</h3>
              <p className="text-blue-100">Execução das soluções com acompanhamento contínuo</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                4
              </div>
              <h3 className="text-xl font-semibold mb-2">Monitoramento</h3>
              <p className="text-blue-100">Avaliação de resultados e ajustes necessários</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-focus-orange text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Pronto para transformar sua empresa?
          </h2>
          <p className="text-xl mb-8 text-red-100 max-w-2xl mx-auto">
            Entre em contato conosco e agende uma consultoria gratuita para descobrir como podemos ajudar seu negócio
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+5511123456789"
              className="bg-white text-focus-orange hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              📞 Ligue Agora
            </a>
            <a
              href="mailto:contato@focus.com.br"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-focus-orange text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              ✉️ Envie um E-mail
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FocusConsultoria;